import useJwt from "@/auth/jwt/useJwt";

/**
 * Return if user is logged in
 * This is completely up to you and how you want to store the token in your frontend application
 * e.g. If you are using cookies to store the application please update this function
 */
// eslint-disable-next-line arrow-body-style
export const isUserLoggedIn = () => {
  return localStorage.getItem("userData") && localStorage.getItem(useJwt.jwtConfig.storageTokenKeyName);
};

export const userRole = () => {
  const userData = localStorage.getItem("userData");
  if (userData !== null) {
    return JSON.parse(userData).type;
  }
  return 0;
};
export const getUserData = (refresh = false) => {
  let emptyUser = {
    type: 0,
    email: "",
    name: ""
  };
  const userData = localStorage.getItem("userData");
  if (userData !== null) {
    return JSON.parse(userData);
  }
  if (refresh) {
    let user = window.http.get("/me");
    if (user.status !== 200) {
      return emptyUser;
    }
    return user;
  }
  return emptyUser;
};

export const mustChangePassword = (user = null) => {
  const data = user || getUserData();
  return !!(data && data.must_change_password);
};

export const userCanUseNetwork = user => {
  return [5, 6].includes(user?.perfil_id || 0) && user?.store?.is_network_member;
};

/**
 * Quem pode editar textos de ajuda contextual (ContextualHelpBlock).
 * Ajuste conforme o payload real do /me e do userData (slug do perfil, flags, etc.).
 */
export const isImpersonating = () => {
  const userData = localStorage.getItem('userData');
  if (userData) {
    return JSON.parse(userData).impersonator !== undefined;
  }
  return false;
};

export const userCanEditContextualHelp = () => {
  const u = getUserData();
  if (!u) {
    return false;
  }
  if (Number(u.perfil_id) === 5 || Number(u.perfil?.id) === 5) {
    return true;
  }
  return false;
};
